<template>
  <div class="grid_row">
    <v-card class="ma-2" elevation="6">
      <div class="ma-2">
        <div class="d-flex">
          <v-icon>mdi-account</v-icon>
          <div class="ml-1">ชื่อ - สกุล</div>
        </div>
        <div class="grid_half">
          <div class="mt-3 mr-1">
            <v-text-field color="#86bc3a" label="ชื่อ - สกุล" prepend-inner-icon="mdi-account-outline" :rules="[v => !!v || 'กรุณากรอกชื่อ - สกุล']" hide-details="auto" required v-model="contact_from.name" outlined></v-text-field>
          </div>
          <div class="mt-3 mr-1">
            <v-text-field color="#86bc3a" label="เบอร์โทรศัพท์" type="tel" maxlength="10" @keypress="isNumber($event, contact_from.telephone)" prepend-inner-icon="mdi-phone-outline" hide-details="auto" v-model="contact_from.telephone" outlined></v-text-field>
          </div>
        </div>
        <div class="grid_full">
          <div class="mt-3 mr-1">
            <v-text-field color="#86bc3a" label="อีเมล" prepend-inner-icon="mdi-email-outline" hide-details="auto" v-model="contact_from.email" outlined></v-text-field>
          </div>
        </div>
        <div class="d-flex mt-4">
          <v-icon>mdi-map-marker</v-icon>
          <div class="ml-1">พิกัด</div>
        </div>
        <div class="grid_half">
          <div class="mt-3 mr-1">
            <v-text-field color="#86bc3a" label="ลองจิจูด" prepend-inner-icon="mdi-map-marker-outline" hide-details="auto" v-model="contact_from.lng" outlined></v-text-field>
          </div>
          <div class="mt-3 mr-1">
            <v-text-field color="#86bc3a" label="ละติจูด" prepend-inner-icon="mdi-map-marker-outline" hide-details="auto" v-model="contact_from.lat" outlined></v-text-field>
          </div>
        </div>
        <div class="d-flex mt-4">
          <v-icon>mdi-home</v-icon>
          <div class="ml-1">ที่อยู่</div>
        </div>
        <div class="grid_full">
          <div class="mt-3">
            <div class="ml-1">บ้านเลขที่/ที่อยู่</div>
            <v-text-field class="mt-2 mr-1" color="#86bc3a" placeholder="ที่อยู่" hide-details="auto" required v-model="contact_from.address" outlined></v-text-field>
          </div>
        </div>
        <div class="grid_half">
          <div class="mt-3 mr-1">
            <addressinput-subdistrict :store="mainDataStore" class="custom_css" placeholder="ตำบล/แขวง" v-model="contact_from.sub_district"/>
          </div>
          <div class="mt-3 mr-1">
            <addressinput-district :store="mainDataStore" class="custom_css" placeholder="อำเภอ/เขต" v-model="contact_from.district"/>
          </div>
          <div class="mt-3 mr-1">
            <addressinput-province :store="mainDataStore" class="custom_css" placeholder="จังหวัด" v-model="contact_from.province" />
          </div>
          <div class="mt-3 mr-1">
            <addressinput-zipcode numbered :store="mainDataStore" class="custom_css" placeholder="รหัสไปรษณีย์" v-model="contact_from.postcode" />
          </div>
        </div>
        <div class="text-center">
          <v-btn large @click="createContact()" class="pa-6 mt-8 grad-success-bg white--text" style="font-size: 18px">บันทึกข้อมูล</v-btn>
          <!--        <v-btn large class="pa-6 mt-8 ml-2 grad-danger-bg white&#45;&#45;text" style="font-size: 18px">ยกเลิก</v-btn>-->
        </div>
      </div>
    </v-card>
    <v-card class="ma-2" elevation="0">
      <h2 class="ml-1 map_header">Contact Us with address here!</h2>
      <div class="mt-4">
        <!--                <span>{{ contact_get.address }} {{ contact_get.sub_district }} {{ contact_get.district }} {{ contact_get.province }} {{ contact_get.postcode }}</span><br/>-->
        <span>บริษัท ฟาร์มาแคร์ พลัส จำกัด 197/3-4 ม.1 ต.ป่าแดด</span><br/>
        <!--                <span>โทร: 054-275-124 แฟ็กซ์: -</span>-->
        <span>โทร: {{ contact_get.telephone }} แฟ็กซ์: -</span>
      </div>
      <div class="mt-4">
        <GmapMap
            :center="center"
            :zoom="15"
            map-type-id="terrain"
            style="width: 100%; height: 500px">
          <GmapMarker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              :clickable="true"
              :draggable="true"
              @click="center=m.position"
          />
        </GmapMap>
      </div>
    </v-card>
  </div>
</template>

<script>
import { HTTP } from '@/axios.js'
import Swal from 'sweetalert2'
import { DataStore,  } from 'vue-thailand-address';
import {isTelephone} from "@/js/handler";
const mainDataStore = new DataStore();

export default {
  name: "ManageContact",
  components: {

  },
  data() {
    return {
      mainDataStore,
      center: { lat: 18.7857502, lng: 98.9907126 },
      markers: [
          {
          position:
              {
                lat: 18.7857502,
                lng: 98.9907126
              }
        },
      ],
      contact_from: {
        id: null,
        name: null,
        telephone: null,
        email: null,
        lng: null,
        lat: null,
        address: null,
        sub_district: null,
        district: null,
        province: null,
        postcode: null
      },
      contact_get: [],
    }
  },
  methods: {
    createAlert() {
      Swal.fire('บันทึกข้อมูลเรียบร้อย','', 'success',);
    },
    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    createContact() {
      HTTP.post('/manage-website/contactus/create', {
        name: this.contact_from.name,
        telephone: this.contact_from.telephone,
        email: this.contact_from.email,
        longtitude: this.contact_from.lat,
        latitude: this.contact_from.lng,
        address: this.contact_from.address,
        sub_district: this.contact_from.sub_district,
        district: this.contact_from.district,
        province: this.contact_from.province,
        postcode: this.contact_from.postcode,
      }, {
        headers: {
          "Authorization": null
        }
      }).then((res) => {
        if (res.data.success === true) {
          this.contact_from.name = null;
          this.contact_from.telephone = null;
          this.contact_from.email = null;
          this.contact_from.lat = null;
          this.contact_from.lng = null;
          this.contact_from.sub_district = null;
          this.contact_from.district = null;
          this.contact_from.province = null;
          this.contact_from.postcode = null;
          this.createAlert();
        }
      })
    },
    getContact() {
      HTTP.post('/manage-website/contactus/all')
          .then((res) => {
            if (res.data.success === true){
              this.contact_get = res.data.object;
            }
          })
    }
  },
  mounted() {
    this.getContact();
  }
}
</script>

<style scoped>
.custom_css >>> input {
  font-size: 18px;
  border-color: #9b9b9b;
  border-radius: 5px;
  padding: 16px;
  height: 56px !important;
}
.custom_css >>> input:hover {
  border-color: black;
}
.custom_css >>> input:focus {
  border-color: #8cc63e !important;
  border: solid 2px;
  padding: 15px;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_row {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px 0;
}
@media only screen and (max-width: 1100px) {
  .grid_row {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
.card_content {
  width: 95%;
  padding: 4%;
}
@media only screen and (max-width: 500px){
  .grid_row {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .map_header {
    text-align: center;
  }
}
</style>
